var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteRedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1842 4.50684C10.1842 4.50684 9.86404 8.47841 9.67828 10.1514C9.58983 10.9504 9.09626 11.4186 8.28779 11.4334C6.74928 11.4611 5.20901 11.4628 3.67109 11.4304C2.89329 11.4145 2.40797 10.9404 2.32128 10.1555C2.13435 8.4678 1.81592 4.50684 1.81592 4.50684",
    stroke: "#F64040",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.60246H1",
    stroke: "#F64040",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07312 2.60333C8.61021 2.60333 8.21158 2.27606 8.12077 1.82258L7.97747 1.10552C7.88902 0.774699 7.58945 0.545898 7.24802 0.545898H4.75185C4.41042 0.545898 4.11086 0.774699 4.02241 1.10552L3.87911 1.82258C3.7883 2.27606 3.38967 2.60333 2.92676 2.60333",
    stroke: "#F64040",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRedIcon);
export default __webpack_public_path__ + "static/media/deleteRedIcon.e3acceee6f375660a8ad6cd5019d9846.svg";
export { ForwardRef as ReactComponent };